// WAV encoder — supports 16/24-bit PCM and 32-bit float
export function audioBufferToWav(buffer, bitDepth = 16) {
  const numCh = buffer.numberOfChannels;
  const sampleRate = buffer.sampleRate;
  const format = bitDepth === 32 ? 3 : 1; // 3 = IEEE float
  const bytesPerSample = bitDepth / 8;
  const chans = [];
  for (let i = 0; i < numCh; i++) chans.push(buffer.getChannelData(i));
  const frames = buffer.length;
  const dataLength = frames * numCh * bytesPerSample;
  const arr = new ArrayBuffer(44 + dataLength);
  const view = new DataView(arr);
  let offset = 0;
  const writeStr = (s) => { for (let i = 0; i < s.length; i++) view.setUint8(offset++, s.charCodeAt(i)); };
  writeStr("RIFF");
  view.setUint32(offset, 36 + dataLength, true); offset += 4;
  writeStr("WAVE");
  writeStr("fmt ");
  view.setUint32(offset, 16, true); offset += 4;
  view.setUint16(offset, format, true); offset += 2;
  view.setUint16(offset, numCh, true); offset += 2;
  view.setUint32(offset, sampleRate, true); offset += 4;
  view.setUint32(offset, sampleRate * numCh * bytesPerSample, true); offset += 4;
  view.setUint16(offset, numCh * bytesPerSample, true); offset += 2;
  view.setUint16(offset, bitDepth, true); offset += 2;
  writeStr("data");
  view.setUint32(offset, dataLength, true); offset += 4;
  for (let i = 0; i < frames; i++) {
    for (let c = 0; c < numCh; c++) {
      let s = chans[c][i];
      if (format === 3) {
        view.setFloat32(offset, s, true); offset += 4;
      } else if (bitDepth === 16) {
        s = Math.max(-1, Math.min(1, s));
        view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true); offset += 2;
      } else {
        s = Math.max(-1, Math.min(1, s));
        let val = Math.round(s < 0 ? s * 0x800000 : s * 0x7fffff);
        view.setUint8(offset++, val & 0xff);
        view.setUint8(offset++, (val >> 8) & 0xff);
        view.setUint8(offset++, (val >> 16) & 0xff);
      }
    }
  }
  return new Blob([view], { type: "audio/wav" });
}
